import React, { Component } from 'react';
import FormExplanationValidation from './FormExplanationValidation';

class FormInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isShown: false
        }

        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onPwdToggle = this.onPwdToggle.bind(this);
    }

    onChange(e) {
        this.props.onChange(e);
    }

    onKeyPress(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            
            if (this.props.onEnter == null) {
                return;
            }
            this.props.onEnter(e);
        }
    }

    onPwdToggle(e) {
        var toggleState = !(this.state.isShown === true);
        this.setState({
            isShown: toggleState
        });
    }

    render() {
        let requiredMark = this.props.required && !this.props.readonly ? <span className="required-mark">*</span> : null;

        var type = "text";
        if (this.props.type === "password" && !this.state.isShown) {
            type = "password";
        }

        var autocomplete = (this.props.autocomplete) ? this.props.autocomplete : "no-autocomplete";
        
        return (
            <div className="tr">
                <div className="FieldLabel td">
                    <label htmlFor={this.props.readonly ? null : this.props.id}>{this.props.text}
                        {requiredMark}
                    </label>
                </div>
                {
                    (this.props.readonly) ?
                        <div className="EditingFormValueCell td"><p className="form-control-static">{this.props.value}</p></div> : 
                        <div className="EditingFormValueCell td">
                            <input type={type} id={this.props.id} disabled={this.props.disabled} autoComplete={autocomplete} ref={el => this.el = el}
                                maxLength={this.props.maxlength} className="form-control" onChange={this.onChange} onKeyPress={this.onKeyPress} value={this.props.value} />
                            {this.props.type === "password" ?
                                <i className={this.state.isShown ? "pwd fa fa-eye-slash" : "pwd fa fa-eye"} onClick={this.onPwdToggle}></i>
                                : ""
                            }
                            <FormExplanationValidation id={this.props.id} explanation={this.props.explanation} showValidation={this.props.showValidation} validationText={this.props.validationText} />
                        </div>
                }
            </div>
        );
    }
}

export default FormInput;


// WEBPACK FOOTER //
// ./src/Fields/FormInput.js